import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Signup, Education } from '@app/_models';
import { State } from '@app/_models/signups/geography';
import { SignupService } from '@app/_services';
import { FadvAlternateAlertComponent, FadvDatePickerComponent, FadvMenuComponent, FadvScrollerComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';
import { EmptyStringValidator } from '@app/_helpers';
import { GeographyService, AlertService } from '@app/_services';
@Component({
  selector: 'app-payment-extended',
  templateUrl: './payment-extended.component.html',
  styleUrls: ['./payment-extended.component.less']
})
export class PaymentExtendedComponent implements OnInit {
  paymentExtra: UntypedFormGroup;
  @ViewChild('ccaddress') ccaddressChild;
  @ViewChild('cccity') cccityChild;
  @ViewChild('ccregion') ccregionChild;
  @ViewChild('ccpostal') ccpostalChild;
  ccaddress: string;
  cccity: string;
  ccregion: string;
  cccountry: string;
  ccpostal: string;
  ccaddressInvalid: boolean = false;
  cccityInvalid: boolean = false;
  ccregionInvalid: boolean = false;
  ccpostalInvalid: boolean = false;
  cccountryInvalid: boolean = false;
  invalid: boolean = true;
  selectedState = new State();
  tempZip: string;
  loading: boolean = false;
  constructor(
    private formBuilder: UntypedFormBuilder, 
    private geographyService: GeographyService,
    private alertService: AlertService) {   }

    ngOnInit(): void {
      this.paymentExtra = this.formBuilder.group({
        ccaddress: ['', [Validators.required, EmptyStringValidator]],
        cccity: ['', [Validators.required, EmptyStringValidator]],
        ccregion: ['', [Validators.required, EmptyStringValidator, Validators.pattern('[a-z A-Z]+$')]],
        cccountry: ['US', [Validators.required, EmptyStringValidator, Validators.minLength(2), Validators.maxLength(2)]],
        ccpostal: ['', [Validators.required, EmptyStringValidator, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]]
      })
    }
  
    showValidation(field: string){
      if(this.paymentExtra.controls[field].invalid){
          this[field+"Invalid"] = true;
          this.invalid = true;
      }
      else{
          this[field+"Invalid"] = false;
          this.invalid = false;
      }
  }
  
  getStateByZip() {
    this.loading = true;
    this.tempZip = this.paymentExtra.controls.ccpostal.value;
    if (this.tempZip != '' && this.tempZip.length === 5 && !isNaN(Number(this.tempZip))){
      this.geographyService.getStatesByPostalCode(this.tempZip).subscribe(data => {
        if(data[0] != undefined) {
          this.ccpostalInvalid = false;
          this.invalid = false;
          this.loading = false;
          this.selectedState = data[0];
          this.paymentExtra.patchValue({
            ccregion: this.selectedState.name
          });
        }
        else
        {
          this.alertService.error("Make sure you have a valid zip")
          this.ccpostalInvalid = true;
          this.invalid = true;
          this.loading = false;
          this.paymentExtra.controls['ccpostal'].setErrors({'invalid': true})
          this.paymentExtra.patchValue({
            ccregion: '',
            ccpostal: ''
          });
        }
      });
    }
    else
    {
      this.alertService.error("Make sure you have a valid zip")
      this.loading = false
      this.paymentExtra.patchValue({
        ccregion: '',
        ccpostal: ''
    })
      this.ccpostalInvalid = true;
      this.invalid = true;
    };
  }

  checkValid(){
    var anyInvalid = false;

    if(this.paymentExtra.controls['ccaddress'].invalid || this.paymentExtra.controls['ccaddress'].value == ''){
      anyInvalid = true;
      this.ccaddressInvalid = true;
    }
    else{
      this.ccaddressInvalid = false;
    }

    if(this.paymentExtra.controls['ccpostal'].invalid || this.paymentExtra.controls['ccaddress'].value == ''){
      anyInvalid = true;
      this.ccpostalInvalid = true;
    }
    else{
      this.ccpostalInvalid = false;
    }

    if(this.paymentExtra.controls['cccity'].invalid || this.paymentExtra.controls['ccaddress'].value == ''){
      anyInvalid = true;
      this.cccityInvalid = true;
    }
    else{
      this.cccityInvalid = false;
    }

    if(this.paymentExtra.controls['ccregion'].invalid || this.paymentExtra.controls['ccaddress'].value == ''){
      anyInvalid = true;
      this.ccregionInvalid = true;
    }
    else{
      this.ccregionInvalid = false;
    }

    if(anyInvalid){
      this.invalid = true;
    }
    else{
      this.invalid = false;
    }
  }

}
